import module from './module.js'
// Components
import './components/lista/component.js'
import './components/lista/empresa/component.js'
import './components/lista/prestamo/component.js'
// Routes
import './routes/prestamosExternos.js'
// Services
import './services/PrestamosExternos.js'
import './services/PrestamosExternos/Abonos.js'
import './services/PrestamosExternos/Conceptos.js'
import './services/PrestamosExternos/Reporte.js'

export default module.name



// WEBPACK FOOTER //
// ./src/prestamosExternos/index.js